
import React, { useEffect, useState } from "react";
import "./WelcomeScreen.css";

const WelcomeScreen = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => onFinish(), 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`welcome-container ${fadeOut ? "fade-out" : ""}`}>
      <img 
        src="/wishare-full-logo.png" 
        alt="Wishare" 
        className="breathing-logo"
      />
      <div className="loading-dots">
        <div className="loading-dot"></div>
        <div className="loading-dot"></div>
        <div className="loading-dot"></div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
